<template>
    <div id="contenedor-eliminar-proyecto-comentario">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar comentario </v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar el comentario?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="No" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarProyectoComentario"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Si">
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import mixProyectoComentarios from './mixProyectoComentarios';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarProyectoComentario',
  mixins: [mixProyectoComentarios],
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
    proyectoComentarioEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style lang="scss" scoped></style>
